/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

/** The framework used to author a particular application or component. */
export enum Framework {
  Angular = 'angular',
  ACX = 'acx',
  Wiz = 'wiz',
}
